import { LoginResponseDto } from "@/data/dto/login-response-dto";
import { LoginRequestPayload } from "@/data/payload/login-request-payload";
import { AuthRepository } from "@/domain/repository/auth-repository";
import { LoginRepository } from "@/domain/repository/login-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class LoginUsecase {
  //MARK:- init
  constructor(
    private readonly loginRepo: LoginRepository,
    private readonly authRepo: AuthRepository
  ) {}

  //MARK: - execute
  async execute(
    email: string,
    password: string
  ): Promise<SATResult<LoginResponseDto, SATError>> {
    const loginPayload: LoginRequestPayload = {
      loginId: email,
      sn: password,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Seoul",
    };

    const loginResponse = await this.loginRepo.login(loginPayload);
    if (loginResponse.isFailure) {
      return SATResult.failure(loginResponse.error);
    }

    const exchangeAESKeyResult = await this.authRepo.exchangeAndSaveAESecretKeyByCookie();
    if (exchangeAESKeyResult.isFailure) {
      return SATResult.failure(exchangeAESKeyResult.error);
    }

    console.log("[LoginUsecase] :: execute :: 로그인 성공");
    return SATResult.success(loginResponse.value);
  }
}
